import script from "./QATopics.vue?vue&type=script&setup=true&lang=js"
export * from "./QATopics.vue?vue&type=script&setup=true&lang=js"

import "./QATopics.vue?vue&type=style&index=0&id=52b94b3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52b94b3e"]])

export default __exports__